/* Variables */
const style = document.createElement('style');
const img1 = require("url:../assets/diag2.webp")
const img2 = require("url:../assets/diag1.webp")

/* Class Diagnostico */
export class DiagnosticoPage extends HTMLElement {

    connectedCallback() {
        this.render();
    }

    render() {
        this.className = 'diagnostico-page';
        this.innerHTML =
        `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">
                    <div class="body__cuerpo diagnostico__cuerpo">
                        <div class="body__cuerpo-text">
                            <br>
                            <h3 class="body__cuerpo-text-title">Diagnóstico por Imágenes</h3>
                            <br>
                            <h5 class="body__cuerpo-text-subtitle">En nuestro centro, contamos con una variedad de tecnologías y especialidades para brindarle un diagnóstico preciso y confiable.<br>Nuestro equipo de expertos en diagnóstico por imágenes trabajará en estrecha colaboración con usted y su médico para comprender sus necesidades y brindarle un cuidado personalizado. En nuestro departamento, encontrará servicios tales como Tomografía Computada, Radiología General, Digestiva, Mastológica e Intervencionista, Mamografía y Ecografía.<br>La Tomografía Computada es una herramienta avanzada que nos permite obtener imágenes detalladas de su cuerpo, ayudando a identificar y evaluar diversas afecciones médicas. Nuestra radiología general está equipada con tecnología de última generación para obtener imágenes precisas de diferentes partes del cuerpo, ofreciendo un diagnóstico completo.<br>Además, contamos con especialidades específicas, como la radiología digestiva, que nos permite visualizar y evaluar el sistema gastrointestinal, y la radiología mastológica e intervencionista, que se centra en el diagnóstico y tratamiento de enfermedades de las mamas.<br>No podemos olvidar la importancia de la mamografía en el diagnóstico temprano del cáncer de mama. Nuestro departamento está equipado con la última tecnología en mamografía, brindando un examen rápido y preciso para la detección temprana de esta enfermedad.<br>Por último, pero no menos importante, nuestra ecografía es una herramienta segura y eficaz para evaluar diferentes partes del cuerpo. Proporciona imágenes en tiempo real que nos permiten detectar y diagnosticar diversas afecciones con precisión.<br><br>• Jefe de Servicio<br>Dr. Vettorazzi Román - M.P. 26.009/3<br><br>• Profesionales Médicos<br>Dr. Di Giorgio Roberto - M.P. 16.733<br>Dra. Dodero María de los Ángeles - M.P. 34.596<br>Dr. Selak Franco - M.P. 34.027/2<br>Dr. Balerdi Rodolfo - M.P. 23.443<br><br>• Licenciados en Diagnóstico en Bio Imágenes<br>Lic. Basualdo José<br>Lic. Escudero Evangelina<br>Lic. Ferreyra Pablo<br>Lic. Gallardo Martin<br>Lic. Perez Marina<br>Lic. Requelme Noelia</h5>
                            <h5 class="body__cuerpo-text-subtitle">• Contacto:</h5>
                            <div class="service-actions">
                                <a class="service-btn" href="/horarios">Horarios</a>
                                <a class="service-btn" href="https://api.whatsapp.com/send?phone=543585610243&text&source&data&app_absent&lang=es">WhatsApp</a>
                                <a class="service-btn" href="mailto:diagnostico@sanatorioprivado.com.ar">Email</a>
                            </div>
                        </div>
                        <div class="body__cuerpo-text">
                            <h5 class="body__cuerpo-text-subtitle">Preparación para Estudios</h5>
                            <div class="body__cuerpo-box">
                                <a class="link" href="#">TAC sin contraste</a>
                                <a class="link" href="#">TAC con contraste</a>
                                <a class="link" href="#">TAC Abdomen con contraste</a>
                                <a class="link" href="#">Ecografia Tiroidea / Testicular / Partes Blandas</a>
                                <a class="link" href="#">Eco Doppler Arterial y/o Venoso</a>
                                <a class="link" href="#">Ecografia Ginecologica / Renal / Vesico / Prostatica</a>
                                <a class="link" href="#">Ecografia Intravaginal</a>
                                <a class="link" href="#">Ecografia Obstetricia / Doppler</a>
                                <a class="link" href="#">Ecografia Abdominal / Hepatobiliar y Pancreatica</a>
                                <a class="link" href="#">Ecografia Mamaria</a>
                                <a class="link" href="#">Mamografia</a>
                                <a class="link" href="#">Punción Tiroidea guiada por Ecógrafo</a>
                                <a class="link" href="#">Punción Biopsia Mamaria</a>
                                <a class="link" href="#">Punción Biopsia Partes Blandas</a>
                                <a class="link" href="#">Punción Biopsia Hepática</a>
                            </div>
                            <div class="body__cuerpo-box">
                                <img src="${img1}" class="body__cuerpo-fotos" alt="Diagnóstico por imágenes" loading="lazy">
                                <img src="${img2}" class="body__cuerpo-fotos" alt="Diagnóstico por imágenes" loading="lazy">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `
        style.innerHTML =
        `
        .diagnostico__cuerpo{
            flex-direction: column;
        }
        `
        this.appendChild(style)
    }
}

/* Define */
customElements.define("diagnostico-page", DiagnosticoPage)
